import URI from 'urijs';
import Cookies from 'js-cookie';
import Storage from '@/js/libs/Storage';

window.URI = URI;

class URIUtils {
    static haveSameDomain(one, other) {
        try {
            const oneURI = URI(one);
            const otherURI = URI(other);

            //noinspection JSUnresolvedFunction
            return oneURI.domain() === otherURI.domain();
        } catch (ex) {
            //
        }

        return false;
    }

    static isRedirectedBack(url) {
        try {
            const uri = URI(url);

            //noinspection JSUnresolvedFunction
            return uri.hasQuery('app_history_redirected_back');
        } catch (ex) {
            //
        }

        return false;
    }

    static isRedirectedReferrer(url) {
        try {
            const uri = URI(url);

            //noinspection JSUnresolvedFunction
            return uri.hasQuery('app_history_redirected_referrer');
        } catch (ex) {
            //
        }

        return false;
    }

    static shouldReplaceOld(url) {
        try {
            const uri = URI(url);

            //noinspection JSUnresolvedFunction
            return uri.hasQuery('app_history_replace_old');
        } catch (ex) {
            //
        }

        return false;
    }

    static clearURI(url) {
        try {
            const uri = URI(url);

            //noinspection JSUnresolvedFunction
            return uri.removeQuery('app_history_redirected_back')
                .removeQuery('app_history_redirected_referrer')
                .removeQuery('app_history_replace_old')
                .toString();
        } catch (ex) {
            //
        }

        return url;
    }
}

export default class AppHistory {
    constructor() {
        this.items = Storage.get('app.history', []);

        this.currentUrl = this.getCurrentUrl();

        this.pushItem(this.currentUrl);
        AppHistory.setReferrerCookie(this.items[1]);

        this.hijackBrowserHistory();
    }

    static setReferrerCookie(referrer) {
        if (referrer) {
            Cookies.set('app_history_referrer', referrer, {expires: 1});
        } else {
            Cookies.remove('app_history_referrer');
        }
    }

    setCurrentUrl(url, old) {
        const cleanedUrl = URIUtils.clearURI(url);

        if (URIUtils.shouldReplaceOld(url)) {
            const re = new RegExp('^' + old + '(.*)$');

            this.items = this.items.map((item) => {
                if (re.test(item)) {
                    return item.replace(re, cleanedUrl + '$1');
                }

                return item;
            });

            Storage.set('app.history', this.items);
        }

        if (window.history) {
            window.history.replaceState({}, window.document.title, cleanedUrl);
        }

        return cleanedUrl;
    }

    getCurrentUrl() {
        const url = window.location.href;

        if (URIUtils.isRedirectedBack(url)) {
            const previous = this.popItem();

            return this.setCurrentUrl(url, previous);
        }

        if (URIUtils.isRedirectedReferrer(url)) {
            this.popItem();
            const referrer = this.popItem();

            return this.setCurrentUrl(url, referrer);
        }

        return URIUtils.clearURI(url);
    }

    hijackBrowserHistory() {
        if (!window.history || this.items.length === 1) {
            return;
        }

        window.history.pushState(null, window.document.title, this.currentUrl);

        let listener = () => {
            window.removeEventListener('popstate', listener);
            window.history.back(); // remove pushState

            this.goBack();
        };

        window.addEventListener('popstate', listener);
    }

    goBack(fallback, callback) {
        let referrer = this.popItem() || fallback || window.document.referrer;

        while (referrer === this.currentUrl) {
            referrer = this.popItem();
        }

        if (callback) {
            referrer = callback(referrer);
        }

        AppHistory.setReferrerCookie(this.items[1]);
        window.location.assign(referrer || '/');
    }

    pushItem(item) {
        if (!item || item === this.peekItem() || !URIUtils.haveSameDomain(this.currentUrl, item)) {
            return false;
        }

        this.items.unshift(item);

        Storage.set('app.history', this.items);

        return item;
    }

    replaceItem(item) {
        if (!item || item === this.peekItem() || !URIUtils.haveSameDomain(this.currentUrl, item)) {
            return false;
        }

        this.items.shift();
        this.items.unshift(item);

        Storage.set('app.history', this.items);

        return item;
    }

    popItem() {
        let item = this.items.shift();

        Storage.set('app.history', this.items);

        return item;
    }

    peekItem() {
        return this.items[0];
    }
}
